// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The dark bar every signed-in page wears: Projects, the catalogs, Monitor,
   the dataflow canvas and its dashboard. One component and one stylesheet, so
   the canvas cannot drift into a bar of its own again. */

.yRV9WIMSKUUi76asvRSG {
  height: var(--curio-top-bar-height);
  box-sizing: border-box;
  background-color: var(--curio-top-bar-bg);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px 10px 10px;
  border-bottom: 1px solid var(--curio-top-bar-border);
  flex-shrink: 0;
  font-family: var(--curio-font-family);
}

/* \`contents\`, so the logo sizes against the bar as it always has. */
.Fn4y5nylHkmmyiysyDvO {
  display: contents;
}

.u4PX8vQiYBpldB65Z6Cr {
  max-height: 100%;
  width: auto;
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;
}

/* The page's own controls take whatever the logo and the account leave. A
   size container, so a page can drop labels when that room runs short
   (\`@container\` in its own stylesheet) instead of wrapping the bar. */
.dBHTFNKgh2gY_hGtPZAb {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  container-type: inline-size;
}

.rBdWs4CqVjrzDqFwYIvQ {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ── Bordered pills: Monitor, API Settings, Sign out ─────────────────────── */

.EIhI7xcMcWJoZ0hXnCPC {
  margin: 0;
  background: none;
  border: 1px solid var(--curio-top-bar-control-border);
  border-radius: var(--curio-radius-sm);
  color: var(--curio-text-on-dark-muted);
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 500;
  padding: 5px 12px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}

.EIhI7xcMcWJoZ0hXnCPC:hover {
  color: var(--curio-text-on-dark-muted);
  text-decoration: none;
}

.EIhI7xcMcWJoZ0hXnCPC:focus-visible,
.kMd59v4U_Un3PGOHxQy_:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: 2px;
}

.tAlZVlnH3X9FiIZqmMdN {
  border-color: var(--curio-text-on-dark-muted);
  color: #fff;
}

.tAlZVlnH3X9FiIZqmMdN:hover {
  color: #fff;
}

.MTSnmdcJXKEmsbxfPNyL {
  margin-right: 12px;
}

/* ── Borderless controls a page puts in the slot ─────────────────────────── */

/* A page whose slot is full can set --curio-bar-button-padding-x on its bar
   (the canvas does, to fit its view switch). */
.kMd59v4U_Un3PGOHxQy_ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  margin: 0;
  padding: 0 var(--curio-bar-button-padding-x, 10px);
  background: transparent;
  border: none;
  border-radius: var(--curio-radius-md);
  color: var(--curio-text-on-dark-muted);
  font-family: inherit;
  font-size: var(--curio-font-size-md);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
}

.kMd59v4U_Un3PGOHxQy_:hover:not(:disabled),
.IvYTHjiEM_98esnmPoYz {
  background-color: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark);
  text-decoration: none;
}

.kMd59v4U_Un3PGOHxQy_:disabled {
  cursor: default;
}

/* The down arrow after a menu's name, drawn with borders instead of written as
   "⏷": a written arrow needs a font that has it, and a system without one drew
   a box in its place. */
.R2qmTFOTv1ZMlO1zvITQ::after {
  content: "";
  display: inline-block;
  border-left: 0.3em solid transparent;
  border-right: 0.3em solid transparent;
  border-top: 0.38em solid currentColor;
  opacity: 0.8;
}

/* A thin rule between groups of slot controls. */
.ykBbLNXyvzAPEkattKaD {
  width: 1px;
  height: 24px;
  margin: 0 8px;
  flex-shrink: 0;
  background-color: var(--curio-top-bar-control-border);
}

/* ── The account ─────────────────────────────────────────────────────────── */

.t4nrSMLzjqhknwXmacWc {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ajAUfRkEmPvZlZK5cb_Q {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #fff;
  color: #0F0F11;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: var(--curio-font-size-xs);
  font-weight: 700;
  border: 1px solid #2A2A2E;
  flex-shrink: 0;
}

.ajAUfRkEmPvZlZK5cb_Q img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ohd0hTLtjLM4FYGGSB26 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.n2BEcxigqSrShCwnBFUg {
  color: #fff;
  font-size: var(--curio-font-size-sm);
  font-weight: 500;
  max-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Mhgu8PoLgfYNZBtZuuWq {
  font-size: var(--curio-font-size-xs);
  padding: 3px 10px;
  line-height: 1.3;
}

.s_sydWgg1k5yyoNYV4P_ {
  color: var(--curio-text-on-dark);
  font-size: var(--curio-font-size-md);
  font-weight: 600;
  padding: 6px 10px;
  text-decoration: none;
}

.s_sydWgg1k5yyoNYV4P_:hover {
  color: var(--curio-text-on-dark);
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/GlobalPageHeader.module.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD;EACE,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,oDAAoD;EACpD,cAAc;EACd,qCAAqC;AACvC;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;sEAEsE;AACtE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,+EAA+E;;AAE/E;EACE,SAAS;EACT,gBAAgB;EAChB,qDAAqD;EACrD,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;+CAC+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,kDAAkD;EAClD,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,+CAA+C;EAC/C,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;wBAEwB;AACxB;EACE,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,cAAc;EACd,qDAAqD;AACvD;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* The dark bar every signed-in page wears: Projects, the catalogs, Monitor,\n   the dataflow canvas and its dashboard. One component and one stylesheet, so\n   the canvas cannot drift into a bar of its own again. */\n\n.header {\n  height: var(--curio-top-bar-height);\n  box-sizing: border-box;\n  background-color: var(--curio-top-bar-bg);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px 10px 10px;\n  border-bottom: 1px solid var(--curio-top-bar-border);\n  flex-shrink: 0;\n  font-family: var(--curio-font-family);\n}\n\n/* `contents`, so the logo sizes against the bar as it always has. */\n.logoLink {\n  display: contents;\n}\n\n.logo {\n  max-height: 100%;\n  width: auto;\n  margin-left: 15px;\n  margin-right: 15px;\n  cursor: pointer;\n}\n\n/* The page's own controls take whatever the logo and the account leave. A\n   size container, so a page can drop labels when that room runs short\n   (`@container` in its own stylesheet) instead of wrapping the bar. */\n.slot {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  container-type: inline-size;\n}\n\n.right {\n  margin-left: auto;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ── Bordered pills: Monitor, API Settings, Sign out ─────────────────────── */\n\n.pill {\n  margin: 0;\n  background: none;\n  border: 1px solid var(--curio-top-bar-control-border);\n  border-radius: var(--curio-radius-sm);\n  color: var(--curio-text-on-dark-muted);\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 500;\n  padding: 5px 12px;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.pill:hover {\n  color: var(--curio-text-on-dark-muted);\n  text-decoration: none;\n}\n\n.pill:focus-visible,\n.barButton:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: 2px;\n}\n\n.pillCurrent {\n  border-color: var(--curio-text-on-dark-muted);\n  color: #fff;\n}\n\n.pillCurrent:hover {\n  color: #fff;\n}\n\n.apiSettings {\n  margin-right: 12px;\n}\n\n/* ── Borderless controls a page puts in the slot ─────────────────────────── */\n\n/* A page whose slot is full can set --curio-bar-button-padding-x on its bar\n   (the canvas does, to fit its view switch). */\n.barButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  margin: 0;\n  padding: 0 var(--curio-bar-button-padding-x, 10px);\n  background: transparent;\n  border: none;\n  border-radius: var(--curio-radius-md);\n  color: var(--curio-text-on-dark-muted);\n  font-family: inherit;\n  font-size: var(--curio-font-size-md);\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.barButton:hover:not(:disabled),\n.barButtonActive {\n  background-color: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark);\n  text-decoration: none;\n}\n\n.barButton:disabled {\n  cursor: default;\n}\n\n/* The down arrow after a menu's name, drawn with borders instead of written as\n   \"⏷\": a written arrow needs a font that has it, and a system without one drew\n   a box in its place. */\n.menuCaret::after {\n  content: \"\";\n  display: inline-block;\n  border-left: 0.3em solid transparent;\n  border-right: 0.3em solid transparent;\n  border-top: 0.38em solid currentColor;\n  opacity: 0.8;\n}\n\n/* A thin rule between groups of slot controls. */\n.divider {\n  width: 1px;\n  height: 24px;\n  margin: 0 8px;\n  flex-shrink: 0;\n  background-color: var(--curio-top-bar-control-border);\n}\n\n/* ── The account ─────────────────────────────────────────────────────────── */\n\n.account {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background-color: #fff;\n  color: #0F0F11;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 700;\n  border: 1px solid #2A2A2E;\n  flex-shrink: 0;\n}\n\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.accountColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.userName {\n  color: #fff;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 500;\n  max-width: 110px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.signOut {\n  font-size: var(--curio-font-size-xs);\n  padding: 3px 10px;\n  line-height: 1.3;\n}\n\n.signIn {\n  color: var(--curio-text-on-dark);\n  font-size: var(--curio-font-size-md);\n  font-weight: 600;\n  padding: 6px 10px;\n  text-decoration: none;\n}\n\n.signIn:hover {\n  color: var(--curio-text-on-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `yRV9WIMSKUUi76asvRSG`,
	"logoLink": `Fn4y5nylHkmmyiysyDvO`,
	"logo": `u4PX8vQiYBpldB65Z6Cr`,
	"slot": `dBHTFNKgh2gY_hGtPZAb`,
	"right": `rBdWs4CqVjrzDqFwYIvQ`,
	"pill": `EIhI7xcMcWJoZ0hXnCPC`,
	"barButton": `kMd59v4U_Un3PGOHxQy_`,
	"pillCurrent": `tAlZVlnH3X9FiIZqmMdN`,
	"apiSettings": `MTSnmdcJXKEmsbxfPNyL`,
	"barButtonActive": `IvYTHjiEM_98esnmPoYz`,
	"menuCaret": `R2qmTFOTv1ZMlO1zvITQ`,
	"divider": `ykBbLNXyvzAPEkattKaD`,
	"account": `t4nrSMLzjqhknwXmacWc`,
	"avatar": `ajAUfRkEmPvZlZK5cb_Q`,
	"accountColumn": `ohd0hTLtjLM4FYGGSB26`,
	"userName": `n2BEcxigqSrShCwnBFUg`,
	"signOut": `Mhgu8PoLgfYNZBtZuuWq`,
	"signIn": `s_sydWgg1k5yyoNYV4P_`
};
export default ___CSS_LOADER_EXPORT___;
